// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"28fdd10b","787":"3dd753f2","818":"82e1d75e"}[chunkId] + ".chunk.js";
};